module.exports = __webpack_public_path__ + "img/dexterity.4febe787.svg";